<template>
  <button
    class="klickbox-step-button danger"
    v-if="step.kind !== 'thanks' && step.kind !== 'welcome'"
    @click="stepSetActive(step);modalOpen('delete-step')">
    <i class="icon-kp-delete"></i>
    <span class="step-subtitle">{{ $t('general.actions.delete') }}</span>
  </button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'modalOpen',
    'stepSetActive',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** ButtonDelete.vue?0537f41b
 **/